module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "wrap flex items-center flex-nowrap w-full",
    attrs: {
      "id": "actions-top"
    }
  }, [_c('router-link', {
    staticClass: "inline-flex items-center gap-2 whitespace-nowrap bg-primary text-white px-4 py-2 rounded-lg shadow-sm hover:shadow transition",
    attrs: {
      "to": _vm.back
    }
  }, [_c('i', {
    staticClass: "mask mask-arrow-left bg-white inline-block h-6 w-6 shrink-0"
  }), _vm._v(" "), _c('span', [_vm._v("Retour")])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto flex items-center gap-3"
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89c6e0cc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ActionBar.vue
// module id = 1044
// module chunks = 0